<mat-card class="section-header-card" [style.background-color]="uiData.atp.color">
  <mat-card-title mat-dialog-title class="example-documents-title">
    <mat-icon style="margin-right: 8px;">folder</mat-icon>
    ATP Example Documents Manager
  </mat-card-title>
</mat-card>

<div mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="12px">
    <div fxLayout="row wrap" fxLayoutGap="8px" *ngFor="let docType of exampleDocumentTypes" style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 10px;">
      <span style="min-width: 190px; font-weight: 500; align-self: center;">{{ docType.label }}</span>

      <input type="file"
             [id]="'example-doc-upload-' + docType.key"
             style="display: none;"
             (change)="onExampleDocumentSelected($event, docType.key)">

      <button mat-raised-button color="primary" type="button"
              (click)="triggerExampleDocumentUpload(docType.key)"
              [disabled]="uploadingExampleDocumentType === docType.key">
        <mat-icon>upload_file</mat-icon>
        Upload
      </button>

      <button mat-raised-button color="primary" type="button"
              (click)="downloadExampleDocument(docType.key)"
              [disabled]="!hasExampleDocument(docType.key)">
        <mat-icon>download</mat-icon>
        Download
      </button>

      <button mat-raised-button color="warn" type="button"
              (click)="removeExampleDocument(docType.key)"
              [disabled]="!hasExampleDocument(docType.key)">
        <mat-icon>delete</mat-icon>
        Remove
      </button>
    </div>
  </div>
</div>

<div mat-dialog-actions fxLayoutAlign="end center" style="margin-top: 8px;">
  <button mat-raised-button (click)="close()">Close</button>
</div>
